import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    color: "white",
    display: "flex",
    padding: "22px 12px",
    background: "#0C091B",
    backgroundImage: "url('/images/bg.png')",
    width: "100%",
    justifyContent: "space-between",
    borderBottom: "0.5px solid #FFFFFF",
    alignItems: "center",
  },
  btn: {
    background: "none",
    border: "none",
    outline: "none",
    display: "flex",
    alignItems: "center",
    columnGap: "10px",
    color: "#fff",
  },
  title: {
    fontSize: "18px",
    fontWeight: "500",
    color: "#fff",
    margin: "0px",
    flex: "1",
  },
}));

const MobileHeader = ({ type, communityTitle, goTo }) => {
  const classes = useStyles();
  return (
    <header className={classes.root}>
      <button
        className={classes.btn}
        type="button"
        onClick={() => {
          goTo(type == "member" ? "message" : "list");
        }}
      >
        <i className="fa fa-angle-left"></i>
        <h1 className={classes.title}>
          {type == "member" ? "Thread" : communityTitle}
        </h1>
      </button>
      {type == "message" && (
        <button
          className={classes.btn}
          type="button"
          onClick={() => {
            goTo("member");
          }}
        ></button>
      )}
    </header>
  );
};
export default MobileHeader;
